
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import RefMultiSelect from '@/components/common/RefMultiSelect.vue'
import {normalizeDataForm} from '@/helpers'
import {namespace} from 'vuex-class'

const uiModule = namespace('ui')

@Component({components: {RefMultiSelect}})
export default class EchangeFilter extends Vue {
  @Prop(Number) count!: number
  @Prop(Object) data!: any
  @uiModule.Getter('isLoadingGetter') isLoading: any

  form = {refStatuts: [], typeEchanges: []}

  get isFill() {
    return this.form.refStatuts.length > 0 || this.form.typeEchanges.length > 0
  }

  mounted() {
    if (this.data) {
      Object.keys(this.form).forEach((key) => {
        if (this.data[key]) this.form[key] = normalizeDataForm(this.data[key], this.form[key])
      })
    }
  }

  onSubmitHandler() {
    this.$emit('filter', {...this.form})
  }

  onResetHandler() {
    this.form = {refStatuts: [], typeEchanges: []}
    this.$emit('resetFilter')
  }
}
